import { render, staticRenderFns } from "./FormPemutakhiran.vue?vue&type=template&id=c759c3a8&"
import script from "./FormPemutakhiran.vue?vue&type=script&lang=js&"
export * from "./FormPemutakhiran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports